import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog as MuiDialog, } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { styled } from '../../utils';
import { IconButton } from '../IconButton';
import { DialogActions } from './DialogActions';
import { DialogContent } from './DialogContent';
import { DialogTitle } from './DialogTitle';
const DialogStyled = styled(MuiDialog, {
    shouldForwardProp: (prop) => prop !== 'singleImage',
})(({ theme, singleImage, maxWidth, width }) => ({
    '& .MuiDialog-paper': {
        borderRadius: theme.shape.borderRadius,
        margin: theme.spacing(1),
        padding: theme.spacing(1, 0),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(2),
        },
        ...(singleImage && {
            overflow: 'hidden',
            margin: 0,
            '& .MuiDialogContent-root': {
                overflow: 'hidden',
                paddingLeft: '0',
                paddingRight: '0',
            },
        }),
        ...(maxWidth === undefined && {
            width: width ?? '767px',
            maxWidth: '100%',
        }),
    },
}));
const DialogHeaderStyled = styled('div')({
    display: 'flex',
    alignItems: 'center',
});
const CloseButtonStyled = styled(IconButton)(({ theme }) => ({
    color: theme.palette.white.dark,
    marginLeft: 'auto',
    right: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
        right: theme.spacing(0),
    },
}));
export function Dialog(props) {
    const { children, showCloseIcon = false, singleImage = false, onClose, dialogTitle, dialogActions, contentRef, contentClass, showInfoIcon = false, showWarningIcon = false, dataName, overFlowXHidden, ...otherProps } = props;
    const { t } = useTranslation();
    const handleClose = useCallback((event) => {
        onClose(event, 'backdropClick');
    }, [onClose]);
    const iconVariant = showInfoIcon
        ? 'information'
        : showWarningIcon
            ? 'alert-sign'
            : undefined;
    return (_jsxs(DialogStyled, { "data-name": dataName, scroll: "paper", singleImage: singleImage, onClose: onClose, ...otherProps, children: [(dialogTitle || showCloseIcon || iconVariant) && (_jsxs(DialogHeaderStyled, { children: [_jsx(DialogTitle, { iconVariant: iconVariant, warning: showWarningIcon, children: dialogTitle }), showCloseIcon && (_jsx(CloseButtonStyled, { size: "small", "aria-label": t('common:button_label.close'), onClick: handleClose, variant: "close" }))] })), _jsx(DialogContent, { classes: {
                    root: contentClass,
                }, ref: contentRef, sx: overFlowXHidden ? { overflowX: 'hidden', position: 'relative' } : {}, children: children }), dialogActions && _jsx(DialogActions, { children: dialogActions })] }));
}
